import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { API, MediumDTO, Pagination } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'sb-page-company-details-media',
  templateUrl: './company-details-media.component.html',
  styleUrls: ['./company-details-media.component.scss'],
  standalone: false,
})
export class CompanyDetailsMediaComponent implements OnInit {
  companyId: number;
  loading: boolean;

  media: MediumDTO[] = [];

  maxSize: number = 8;
  boundaryLinks: boolean = true;

  resultCount: number;
  currentCount: number;
  collectionSize: number;

  debounceTimer: ReturnType<typeof setTimeout>;

  pagination: BehaviorSubject<Pagination>;

  paginationString: string;

  paginationInitialized: boolean;

  // tslint:disable-next-line:variable-name
  _page: number;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public permissionService: PermissionService
  ) {
    this.companyId = undefined;
    this.loading = true;
    this.media = [];
    this.maxSize = 8;
    this.boundaryLinks = true;
    this.resultCount = -1;
    this.currentCount = -1;
    this.collectionSize = -1;
    this.debounceTimer = null;
    this.paginationString = '';
    this.paginationInitialized = false;
    this._page = 1;
    this.pagination = new BehaviorSubject<Pagination>({
      page: this.page,
      count: this.maxSize ? this.maxSize : 8,
      pages: -1,
      resultcount: -1,
    });
  }

  get page(): number {
    return this._page;
  }

  set page(val: number) {
    this._page = val;
    this.pagination.value.page = val;
  }

  ngOnInit() {
    this.activatedRoute.parent.params.subscribe(params => {
      this.companyId = +params.companyID;
      this.initPagination();
    });
  }

  pageChange($event) {
    this.page = $event;
    this.requestDebounced();
  }

  initPagination() {
    this.pagination.subscribe((e: Pagination) => {
      this.collectionSize = e.resultcount;
      this.maxSize = e.count;
      this.resultCount = e.resultcount;
      // this.page = e.page;
    });
    this.refreshFromServer();
  }

  requestDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.loading = true;
    this.api
      .mm_Medium_retrieveAll(
        {
          company: [this.companyId],
        },
        this.pagination
      )
      .subscribe({
        next: (res: MediumDTO[]) => {
          this.media = res;
          this.loading = false;
          this.currentCount = res.length;
          this.paginationString = this.util.getPaginationString(this.page, this.maxSize, this.currentCount, this.resultCount, 'media');
          this.paginationInitialized = true;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }
}
